








































import { Component, Prop, Vue } from "vue-property-decorator";
import { ReferralEspoedDetailsModel } from "@/types/aznconnect_api";
import InformationCard from "@/components/InformationCard.vue";

@Component({
  components: {
    "information-card": InformationCard,
  },
})
export default class MedicalConditionWorkingDiagnosisSectionView extends Vue {
  @Prop()
  advancedMode!: boolean;

  @Prop({ default: null })
  referral!: ReferralEspoedDetailsModel;
}
